import { Fab } from '@mui/material'
import type { CSSProperties } from 'react'
import { useEffect, useState } from 'react'
import IcBaselineKeyboardArrowUp from '~icons/ic/baseline-keyboard-arrow-up'
import { cx } from 'src/utils/cx'

const ScrollTop = (props: { className?: string; style?: CSSProperties }) => {
  const [isVisible, setIsVisible] = useState(false)
  const threshold = 100

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > threshold)
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div
      className={cx(
        'fixed bottom-24 right-6 gap-8 transition-all duration-200 ease-out',
        isVisible
          ? 'pointer-events-auto translate-y-0 scale-100 opacity-100'
          : 'pointer-events-none translate-y-2 scale-95 opacity-0',
        props.className,
      )}
      style={props.style}
    >
      <Fab
        color="secondary"
        size="small"
        className={cx('shadow-md')}
        aria-hidden={!isVisible}
        tabIndex={isVisible ? 0 : -1}
        onClick={() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        }}
      >
        <IcBaselineKeyboardArrowUp />
      </Fab>
    </div>
  )
}

export default ScrollTop
